import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Box, Button, Stack, Typography, styled } from '@mui/material';
import { withStyles } from '@mui/styles';
import { COLORS } from '../../../../utils/Application_Constants';

const StyledButton = styled(Button)(() => ({
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundColor: 'transparent',
    padding: '12px 4px',

    '&:hover': {
        backgroundColor: COLORS.LT_MIDNIGHT5,
    },
}));

const styles = (theme) => ({
    title: {
        fontSize: 9,
        lineHeight: '100%',
        color: COLORS.LT_MIDNIGHT50,
        fontWeight: 600,
        textTransform: 'uppercase',
    },
    name: {
        marginLeft: '17px',
        fontSize: 12,
        lineHeight: '18px',
        color: theme.palette.common.primary,
        fontWeight: 400,
        textDecoration: 'underline',
    },
    nameNoEmail: {
        marginLeft: '0px',
        textDecoration: 'none',
    },
});

const EmailButton = ({ title, name, email, classes }) =>
    email != null ? (
        <StyledButton href={`mailto:${email}`} target="_blank">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <EmailOutlinedIcon sx={{ fontSize: 16, color: COLORS.LT_MIDNIGHT50 }} />
                <Typography className={classes.title}>{title}</Typography>
            </Box>
            <Typography className={classes.name}>{name || 'Not available'}</Typography>
        </StyledButton>
    ) : (
        <Stack sx={{ padding: '12px 4px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography className={classes.title}>{title}</Typography>
            </Box>
            <Typography className={[classes.name, classes.nameNoEmail].join(' ')}>
                {name || 'Not available'}
            </Typography>
        </Stack>
    );

export default withStyles(styles)(EmailButton);
